// ProgressBar.jsx
import React from 'react';
import './index.scss';

const ProgressBar = () => {
  return (
    <div className="progress-container">
      <div className="progress-bar">
        <div className="progress-fill" />
      </div>
    </div>
  );
};

export default ProgressBar;
